export default "__VITE_ASSET__B1BP1jnD__"